import React, { useCallback, useEffect, useMemo, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Button } from "reactstrap"
import { FilterData, IndexType } from "components/Extra"
import DeliveryMenTable from "pages/admin/Delivery-men/DeliveryMenTable"
import { DeliveryMenGrid } from "pages/admin/Delivery-men/DeliveryMenGrid"
import { AddDeliveryMan, BarcodeModal } from "pages/admin/Delivery-men/Modals"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import barcodeImage from "./barcode.png"

export interface DeliveryMan {
  name: string
  id: string
  mobileNumber: string
  availabilityStatus: "Available" | "Delivering"
  address: string
  activeStatus: "Active" | "In Active"
  rate: number
}

interface DeliveryMenProps {
  isDashboardPage?: boolean
}

export const deliveryMenData: DeliveryMan[] = [
  {
    name: "Delivery Man Name",
    id: "ID-145871",
    mobileNumber: "+9745866244",
    availabilityStatus: "Available",
    address: "Delivery Address Goes Here",
    activeStatus: "Active",
    rate: 4.5,
  },
  {
    name: "Delivery Man Name",
    id: "ID-1458722",
    mobileNumber: "+9745866244",
    availabilityStatus: "Delivering",
    address: "Delivery Address Goes Here",
    activeStatus: "In Active",
    rate: 4.0,
  },
  {
    name: "Delivery Man Name",
    id: "ID-145873",
    mobileNumber: "+9745866244",
    availabilityStatus: "Delivering",
    address: "Delivery Address Goes Here",
    activeStatus: "In Active",
    rate: 3.5,
  },
  {
    name: "Delivery Man Name",
    id: "ID-145874",
    mobileNumber: "+9745866244",
    availabilityStatus: "Available",
    address: "Delivery Address Goes Here",
    activeStatus: "Active",
    rate: 5.0,
  },
  {
    name: "Delivery Man Name",
    id: "ID-145875",
    mobileNumber: "+9745866244",
    availabilityStatus: "Delivering",
    address: "Delivery Address Goes Here",
    activeStatus: "Active",
    rate: 4.0,
  },
  {
    name: "Delivery Man Name",
    id: "ID-145876",
    mobileNumber: "+9745866244",
    availabilityStatus: "Available",
    address: "Delivery Address Goes Here",
    activeStatus: "In Active",
    rate: 4.2,
  },
  {
    name: "Delivery Man Name",
    id: "ID-145877",
    mobileNumber: "+9745866244",
    availabilityStatus: "Delivering",
    address: "Delivery Address Goes Here",
    activeStatus: "Active",
    rate: 4.8,
  },
]

export const DeliveryMen: React.FC<DeliveryMenProps> = ({ isDashboardPage }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const [activeTab, setActiveTab] = useState<IndexType>("list-ul")
  const [checkedDeliveryMen, setCheckedDeliveryMen] = useState<DeliveryMan[]>(
    []
  )
  const [deliveryMen, setDeliveryMen] = useState<DeliveryMan[]>([])
  const [filteredDeliveryMen, setFilteredDeliveryMen] = useState<DeliveryMan[]>(
    []
  )
  const [openAddDeliveryMan, setOpenAddDeliveryMan] = useState<boolean>(false)
  const [openBarcodeModal, setOpenBarcodeModal] = useState<boolean>(false)

  useEffect(() => {
    setDeliveryMen(deliveryMenData)
    setFilteredDeliveryMen(deliveryMenData)
  }, [])

  const isAllChecked = useMemo(() => {
    return (
      deliveryMen.length > 0 && checkedDeliveryMen.length === deliveryMen.length
    )
  }, [deliveryMen, checkedDeliveryMen])

  const togglecheckedDeliveryManHandler = useCallback(
    (deliveryMan: DeliveryMan) => {
      setCheckedDeliveryMen(prev =>
        prev.includes(deliveryMan)
          ? prev.filter(d => d !== deliveryMan)
          : [...prev, deliveryMan]
      )
    },
    []
  )

  const toggleAllDeliveryMen = useCallback(() => {
    setCheckedDeliveryMen(isAllChecked ? [] : deliveryMen)
  }, [isAllChecked, deliveryMen])

  const toggleActiveDeliveryMan = useCallback(
    (deliveryMan: DeliveryMan) => {
      setDeliveryMen(prev =>
        prev.map(d =>
          d.id === deliveryMan.id
            ? {
                ...d,
                activeStatus:
                  deliveryMan.activeStatus === "Active"
                    ? "In Active"
                    : "Active",
              }
            : d
        )
      )
    },
    [deliveryMen]
  )

  const addNewDeliveryManHandler = useCallback(() => {
    setOpenAddDeliveryMan(true)
  }, [])

  const openBarcodeModalHandler = useCallback(() => {
    setOpenBarcodeModal(true)
  }, [])

  const printDeliveredBarcodeHandler = useCallback((deliveryMan: DeliveryMan) => {
    setOpenBarcodeModal(true)
  }, [])

  const editDeliveryManHandler = useCallback((deliveryMan: DeliveryMan) => {},
  [])
  const deleteDeliveryManHandler = useCallback((deliveryMan: DeliveryMan) => {},
  [])
  const viewDetailsHandler = useCallback((deliveryMan: DeliveryMan) => {
    navigate(`/delivery-men/${deliveryMan.id}`)
  }, [])

  if (isDashboardPage) {
    return (
      <>
        <FilterData
          data={deliveryMen}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          bearerFilteredData={setFilteredDeliveryMen}
          showFilterBtnInsteadOfToggle
        />

        {/* Modals */}
        <AddDeliveryMan
          isOpen={openAddDeliveryMan}
          toggle={() => setOpenAddDeliveryMan(false)}
        />
        <BarcodeModal
          isOpen={openBarcodeModal}
          toggle={() => setOpenBarcodeModal(false)}
        />
        <DeliveryMenTable
          deliveryMen={filteredDeliveryMen}
          isAllChecked={isAllChecked}
          checkedDeliveryMen={checkedDeliveryMen}
          toggleAllDeliveryMen={toggleAllDeliveryMen}
          togglecheckedDeliveryManHandler={togglecheckedDeliveryManHandler}
          toggleActiveDeliveryMan={toggleActiveDeliveryMan}
          editDeliveryManHandler={editDeliveryManHandler}
          deleteDeliveryManHandler={deleteDeliveryManHandler}
          viewDetailsHandler={viewDetailsHandler}
          printDeliveredBarcodeHandler={printDeliveredBarcodeHandler}
        />
      </>
    )
  }

  return (
    <div className="page-content">
      <div className="container-fluid d-flex justify-content-between align-items-center">
        <Breadcrumbs
          title={t("dashboard_dashboard")}
          breadcrumbItem={t("deliveryMen_deliveryMen")}
        />{" "}
        <div className="d-flex gap-2 align-items-center">
          <Button
            onClick={openBarcodeModalHandler}
            className="btn btn-light border d-flex align-items-center justify-content-center"
            style={{ minWidth: "auto", padding: "0.25rem 0.5rem" }}
          >
            <img
              src={barcodeImage}
              alt="Barcode"
              style={{ height: "32px", width: "auto" }}
            />
          </Button>
          <Button
            onClick={addNewDeliveryManHandler}
            className="bg-gradiant-blue text-capitalize btn btn-secondary border-0"
          >
            {t("deliveryMen_addNewDeliveryMan")}
          </Button>
        </div>
      </div>
      <FilterData
        data={deliveryMen}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        bearerFilteredData={setFilteredDeliveryMen}
      />

      {/* Modals */}
      <AddDeliveryMan
        isOpen={openAddDeliveryMan}
        toggle={() => setOpenAddDeliveryMan(false)}
      />
      <BarcodeModal
        isOpen={openBarcodeModal}
        toggle={() => setOpenBarcodeModal(false)}
      />

      {activeTab == "list-ul" ? (
        <DeliveryMenTable
          deliveryMen={filteredDeliveryMen}
          isAllChecked={isAllChecked}
          checkedDeliveryMen={checkedDeliveryMen}
          toggleAllDeliveryMen={toggleAllDeliveryMen}
          togglecheckedDeliveryManHandler={togglecheckedDeliveryManHandler}
          toggleActiveDeliveryMan={toggleActiveDeliveryMan}
          editDeliveryManHandler={editDeliveryManHandler}
          deleteDeliveryManHandler={deleteDeliveryManHandler}
          viewDetailsHandler={viewDetailsHandler}
          printDeliveredBarcodeHandler={printDeliveredBarcodeHandler}
        />
      ) : (
        <DeliveryMenGrid
          deliveryMen={filteredDeliveryMen}
          editDeliveryManHandler={editDeliveryManHandler}
          deleteDeliveryManHandler={deleteDeliveryManHandler}
          viewDetailsHandler={viewDetailsHandler}
          toggleActiveDeliveryMan={toggleActiveDeliveryMan}
          printDeliveredBarcodeHandler={printDeliveredBarcodeHandler}
        />
      )}
    </div>
  )
}
